import React from 'react';
import { Modal, Icon, Table } from 'semantic-ui-react';

const BulkAddStudentsFromCSVModal = ({
  showBulkAddStudentFromCSVModal,
  setShowBulkAddStudentFromCSVModal,
  isCSVPreviewModalVisible,
  spreadsheetFileRef,
  spreadsheetFile,
  setSpreadSheetFile,
  setBulkImportedStudents,
  setViewBulkImportedStudentsData,
  bulkImportedStudents,
  handleStudentSpreadSheetUpload,
  viewBulkImportedStudentsData,
  setIsCSVPreviewModalVisible,
  addBulkStudentsFromCSVToJobGroupById,
}) => {
  return (
    <Modal
      onClose={() => setShowBulkAddStudentFromCSVModal(false)}
      onOpen={() => setShowBulkAddStudentFromCSVModal(true)}
      open={showBulkAddStudentFromCSVModal}
    >
      <Modal.Header>Bulk Add Students</Modal.Header>
      {!isCSVPreviewModalVisible ? (
        <Modal.Content>
          <Modal.Description>
            <p>
              Note: This action will add students to the job role. Please make
              sure the CSV file is in the correct format.
            </p>
            <div className='w-full px-3 mb-6 md:mb-0'>
              <div className='flex flex-wrap items-center justify-start w-full mt-8 mb-2'>
                <div className='flex items-center justify-center border rounded '>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      spreadsheetFileRef.current.click();
                    }}
                    className='px-5 py-2 font-semibold text-white bg-gray-300 rounded hover:bg-gray-400'
                    style={{ backgroundColor: '#1C5DDB' }}
                  >
                    Upload
                    <span className='ml-2'>
                      <Icon name='upload' />
                    </span>
                  </button>
                  <p className='mx-5 text-xs italic text-gray-500'>
                    {spreadsheetFile?.length > 0
                      ? spreadsheetFile[0].name
                      : 'No file chosen'}
                  </p>
                </div>
                <button className='mx-3'>
                  <Icon
                    onClick={(e) => {
                      e.preventDefault();
                      setSpreadSheetFile([]);
                      setBulkImportedStudents([]);
                      setViewBulkImportedStudentsData([]);
                    }}
                    name='trash alternate outline'
                  />
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  disabled={bulkImportedStudents.length === 0}
                >
                  <Icon
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    name='eye'
                  />
                </button>
              </div>

              <input
                onChange={(e) => {
                  setSpreadSheetFile(e.target.files);
                  handleStudentSpreadSheetUpload(e);
                }}
                type='file'
                ref={spreadsheetFileRef}
                hidden={true}
                accept='.csv, .xlsx'
              />
            </div>
          </Modal.Description>
        </Modal.Content>
      ) : (
        <Modal.Content>
          <Modal.Description>
            <div className='flex flex-wrap justify-start mb-2'>
              {/* <TableContainer component={Paper}> */}
              <Table sx={{ minWidth: 650 }} aria-label='simple table'>
                <Table.Header>
                  <Table.Row>
                    <Table.Cell>Sl no.</Table.Cell>
                    <Table.Cell>Students</Table.Cell>
                    <Table.Cell align='right'>email</Table.Cell>
                    <Table.Cell align='right'>phone</Table.Cell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {viewBulkImportedStudentsData.map((row, index) => (
                    <Table.Row
                      key={row.email}
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                      }}
                    >
                      <Table.Cell component='th' scope='row'>
                        {index + 1}
                      </Table.Cell>
                      <Table.Cell align='right'>{row.name}</Table.Cell>
                      <Table.Cell align='right'>{row.email}</Table.Cell>
                      <Table.Cell align='right'>{row.phone}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
              {/* </TableContainer> */}
            </div>
          </Modal.Description>
        </Modal.Content>
      )}
      {!isCSVPreviewModalVisible ? (
        <Modal.Actions>
          <button
            onClick={(e) => {
              e.preventDefault();
              setShowBulkAddStudentFromCSVModal(false);
            }}
            className='px-8 py-2 ml-8 text-base font-medium border rounded text-gray border-primary-400'
          >
            Cancel
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              setIsCSVPreviewModalVisible(true);
            }}
            className='px-8 py-2 ml-8 text-base font-medium text-white border rounded bg-brand-primary border-primary-400'
          >
            Preview
          </button>
        </Modal.Actions>
      ) : (
        <Modal.Actions>
          <button
            onClick={(e) => {
              e.preventDefault();
              setIsCSVPreviewModalVisible(false);
            }}
            className='px-8 py-2 ml-8 text-base font-medium border rounded text-gray border-primary-400'
          >
            Back
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              addBulkStudentsFromCSVToJobGroupById();
            }}
            className='px-8 py-2 ml-8 text-base font-medium text-white border rounded bg-brand-primary border-primary-400'
          >
            Add Students
          </button>
        </Modal.Actions>
      )}
    </Modal>
  );
};

export default BulkAddStudentsFromCSVModal;
